if(!customElements.get('quizz-component')) {
  class ComponentQuizz extends HTMLElement {
    constructor() {
      super();
      this.resultsData = [];
      this.currentQuestionIndex = 1;
      this.currentQuestion = this.querySelector(`.question-${this.currentQuestionIndex}`);
      this.questions = this.querySelectorAll('.question');
      this.answersBtns = this.querySelectorAll('.answer-btn');
      this.nextBtns = this.querySelectorAll('.next-question');
      this.prevBtns = this.querySelectorAll('.prev-question');

      this.finalBtn = this.querySelector('.final-question');
      this.restartBtns = this.querySelectorAll('button.restart');
      this.resultsContainer = this.querySelector('.results-container');
      this.topProductContainer = this.resultsContainer.querySelector('.top-product-container');
      this.optionalProductsContainer = this.resultsContainer.querySelector('.optional-products');  
      this.optionalSlider = this.optionalProductsContainer.querySelector('.keen-slider');
      this.carousel = this.querySelector('.component-carousel');

      this.currentAnswer = '';
      this.answersCompleted = [];

      this.getResultsFinished = false;
      this.getResultsFailed = false;
      this.quizzCompleted = false;

      this.metricForm = this.querySelector('#metric-form');
      this.sendDataBtn = this.querySelector('.send-data-btn');
      this.sendDataInput = this.querySelector('.form-content input');

      this.fullAnswers = [];
      this.resultProcessed = [];

          

      this.answersBtns.forEach( answer => {
        answer.addEventListener('click', e => {
          if(this.currentAnswer){
            this.currentAnswer.classList.remove('selected');
          }
          answer.classList.add('selected');
          this.currentAnswer = answer;

          this.currentQuestion.querySelector('.submit').removeAttribute('disabled');
        });
      });


      this.nextBtns.forEach( next => {
        next.addEventListener('click', e => {
          this.answersCompleted.push(this.currentAnswer.dataset.answerId);
          this.fullAnswers.push({
            "question": this.currentQuestion.dataset.question,
            "answer": this.currentAnswer.dataset.answer
          })
          this.currentQuestionIndex++;
          this.changeQuestion();

        });
      });

      this.prevBtns.forEach( next => {
        next.addEventListener('click', e => {
          this.answersCompleted.pop();
          this.currentQuestionIndex--;
          this.changeQuestion();
        });
      });

      this.restartBtns.forEach( restart => {
        restart.addEventListener('click', e => {
          this.reset();
        });
      });
      
      this.finalBtn.addEventListener('click', e => {
        $s.showLoadingOverlay();
        this.quizzCompleted = true;
        this.answersCompleted.push(this.currentAnswer.dataset.answerId);
        this.fullAnswers.push({
          "question": this.currentQuestion.dataset.question,
          "answer": this.currentAnswer.dataset.answer
        })
        if(this.getResultsFailed){
          this.somethingWrong();
        }
        else if(this.getResultsFinished){
          this.resolveResults();
        }

      });

      this.getResultsData('/pages/' + this.dataset.page + '?view=quizz_results'); 
      var rawSavedResults = localStorage.getItem(this.dataset.quizHandle);
      if(rawSavedResults){
        this.resultsSaved = JSON.parse(rawSavedResults);
        $s.showLoadingOverlay();
        this.quizzCompleted = true;

        var savedAnswers = localStorage.getItem(this.dataset.quizHandle + "_answers");
        if(savedAnswers){
          this.fullAnswers = JSON.parse(savedAnswers);
        }
        
      }
      
      
      this.metricSetup();

    } 

    metricSetup(){

      this.metricForm.addEventListener('submit', (e)=>{
        e.preventDefault();
        e.stopImmediatePropagation();

        var errorMsg = this.metricForm.querySelector('.error-msg');
        errorMsg.innerHTML = '';
        var successMsg = this.metricForm.querySelector('.success-msg');
        successMsg.classList.add('hide');

        if($s.validateEmail(this.sendDataInput.value)){
          this.sendDataInput.classList.remove('error');
        
          try {
            var procesedAnswers = {};

            this.fullAnswers.forEach((answer, index) => {
              var answerName = `answer_${index + 1}`;
              var singleAnswer = {};
              singleAnswer[answerName] = answer;
              procesedAnswers = {
                ...procesedAnswers,
                ...singleAnswer
              }
            });

            var aditionalProductsIds = [];

            this.resultProcessed.additional_products.forEach(aditionalProd => {
              aditionalProductsIds.push(aditionalProd.id);
            });         
          
             klaviyo.identify({
              'email' : this.sendDataInput.value,
              'top_product': this.resultProcessed.top_product.id,
              'additional_products': aditionalProductsIds,
            }, ()=>{

              const now = new Date();
              const isoDate = now.toISOString();

              klaviyo.track(this.dataset.metric, {
                "user": this.sendDataInput.value,                
                "top_product": this.resultProcessed.top_product.id,
                "additional_products": aditionalProductsIds,
                "date": isoDate,
                ...procesedAnswers
              }).then(result => {
                  successMsg.classList.remove('hide');
              });
            }); 

          } catch (error) {
            console.log("Klaviyo error",error);
            this.somethingWrong();
          }
        }
        else{
          this.sendDataInput.classList.add('error');
          errorMsg.innerHTML = lngg.general__forms__enter_a_valid_email_message;
        }
        


       
      });

    }

    resolveResults(){
      var result = this.getResult();  

      this.resultProcessed = result;

      localStorage.setItem(this.dataset.quizHandle, JSON.stringify(result));
      localStorage.setItem(this.dataset.quizHandle + "_answers" , JSON.stringify(this.fullAnswers));

      this.getResultProducts(result);       

    }

    somethingWrong(){
      $s.openModal('<div class="error-itemincart scheme">'+ "Something went wrong, please refresh the page and try again later."  + '</div>');
    }
    

    changeQuestion(){
      this.currentQuestion.classList.add('hide');
      this.currentQuestion = this.querySelector(`.question-${this.currentQuestionIndex}`);
      this.currentQuestion.querySelector('.submit').setAttribute('disabled',true);
      this.currentQuestion.classList.remove('hide');
      if(this.currentAnswer){
        this.currentAnswer.classList.remove('selected');
      }
      this.currentAnswer = '';

    }

    getResult(){

      if(this.resultsSaved){
        return this.resultsSaved;
      }

      var bestMatch = -1;
      var bestResult = ''
      
      this.resultsData.forEach( result => {
        var resultMatch = 0;
        this.answersCompleted.forEach( answer => {
          if(result.answers.includes(answer)){
            resultMatch++;            
          }
        })

        if(resultMatch > bestMatch){
          bestMatch = resultMatch;
          bestResult = result;
        }
      });

      return bestResult;
    }

    getResultProducts(result){
      var productsWaiting = 0;

      var productsToLoad = [];
      if(result.top_product){
        productsToLoad.push({url: '/products/' + result.top_product.handle + '?section_id=top_result_product_card', top: true});
      }
      else{
        this.topProductContainer.classList.add('hide');
      }

      if(result.additional_products.length > 1){
        result.additional_products.forEach( prod => {
          productsToLoad.push({url: '/products/' + prod.handle + '?section_id=individual_product_card', top: false});
        });
      }
      else{
        this.optionalProductsContainer.classList.add('hide');
      }

      if(productsToLoad.length > 0){
        productsWaiting = productsToLoad.length;

        productsToLoad.forEach( prod => {
          $s.get({
            url: prod.url,
            cache: false,
            success: (data) => {
              if(prod.top){
                this.topProductContainer.innerHTML = data;
              } else {
                var cardElement = document.createElement('div');
                cardElement.innerHTML = data;
                cardElement.classList.add('keen-slider-slide');
                cardElement.firstElementChild.removeAttribute('id');
                cardElement.firstElementChild.removeAttribute('class');

                this.optionalSlider.appendChild(cardElement);
              }
            },
            error: (error) =>{
              console.log("RESULTS PROD ERROR",error);
              this.somethingWrong();
            },
            always: () => {
              productsWaiting--;
              if(productsWaiting == 0){
                this.currentQuestion.classList.add('hide');
                this.resultsContainer.classList.remove('hide'); 
                $s.hideLoadingOverlay();  
                if(result.additional_products.length > 1){
                  this.carousel.initSlider();  
                  
                    $s.resizeWidthHandle(this.layout); 
                     
                                   
                }   
              }
            }
          })

        });
      } else {
        console.log("NO PRODUCTS");
        this.somethingWrong();
      }        


    }

    layout() {
      $s.matchHeight(document.querySelectorAll('.optional-products .common-card .title'));
    }

    reset(){
      this.answersCompleted = [];
      this.fullAnswers = [];
      this.resultsContainer.innerHtml = '';
      this.currentQuestionIndex = 1;
      this.currentQuestion.classList.add('hide');
      this.resultsContainer.classList.add('hide');              

      this.currentQuestion = this.querySelector(`.question-${this.currentQuestionIndex}`);
      this.currentQuestion.classList.remove('hide');

      this.optionalSlider.innerHTML = '';
      this.carousel.removeSlider();

      this.nextBtns.forEach( next => {
        next.setAttribute('disabled', true);
      });
      
      this.answersBtns.forEach( answer => {
        answer.classList.remove('selected');
      });

      localStorage.removeItem(this.dataset.quizHandle);
      localStorage.removeItem(this.dataset.quizHandle + "_answers");

      this.resultsSaved = '';

      $s.scrollToElement(this);
      
    }

    getResultsData(url){
      $s.get({
        url: url,
        cache: false,
        success: (data) => {
          var jsonData = JSON.parse(data);

          this.resultsData.push(...jsonData.results);
          if(jsonData.next_page){
            this.getResultsData(jsonData.next_page);
          }
          else{
            this.getResultsFinished = true;
            if(this.quizzCompleted){
              this.resolveResults();
            }
          }
        },
        error: (error) =>{
          console.log("RESULTS DATA ERROR",error);
          this.getResultsFailed = true;
        }
      })


    }





  }
  customElements.define('quizz-component', ComponentQuizz);
}